<div class="field-container">
  @if (props['label']) {
  <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
  <label class="field-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }

  @if (props['description']) {
  <p class="field-description">{{ props['description'] }}</p>
  }

  <div class="select-list" [class.is-multiple]="isMultiple" [attr.data-testid]="'field-select-list'">
    @if (props['placeholder'] && !isMultiple) {
    <button type="button" class="select-option placeholder-option" [class.selected]="!formControl.value"
      (click)="selectOption(null)" [attr.data-testid]="'field-select-placeholder'">
      <span class="option-label">{{ props['placeholder'] }}</span>
      @if (!formControl.value) {
      <app-icon name="check" class="check-icon" />
      }
    </button>
    }
    @for (option of selectOptions; track option.value) {
    <button type="button" class="select-option" [class.selected]="isSelected(option.value)"
      (click)="selectOption(option.value)" [attr.data-testid]="'field-select-option-' + option.value">
      <div class="option-content">
        <span class="option-label">{{ option.label }}</span>
        @if (option.description) {
        <span class="option-description">{{ option.description }}</span>
        }
      </div>
      @if (isSelected(option.value)) {
      <app-icon name="check" class="check-icon" />
      }
    </button>
    }
  </div>

  @if (formControl.touched && formControl.errors) {
  <div class="field-error" [attr.data-testid]="'field-select-error'">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    }
  </div>
  }
</div>